import { Component, OnInit, ViewContainerRef } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { UserSettingsService } from "src/app/shared/services/user-setting.service";
import { Setting } from "src/app/shared/setting";
import { environment } from "src/environments/environment";
import { CustomNotificationService } from "src/app/shared/services/custom.notification.service";
import { LoginModel } from "src/app/shared/model/login-model";
import { AuthService } from "src/app/shared/services/auth.service";
import { NzModalService } from "ng-zorro-antd/modal";
import { CreateOrganizationComponent } from "../sign-up/create-organization/create-organization.component";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  standalone: false,
})

export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  isLoading = false;
  isProd = true;
  recaptchaWebToken: string;
  token: string | undefined;
  showModal: boolean = false;
  passwordVisible: boolean = false;
  appName: string;

  constructor(
    private readonly fb: UntypedFormBuilder,
    private  readonly notification: CustomNotificationService,
    public setting: Setting,
    public authService: AuthService,
    public userServices: UserSettingsService,
    private readonly router: Router,
    private readonly modalService: NzModalService,
    private readonly viewContainerRef: ViewContainerRef
  ) {
    this.token = undefined;
    this.isProd = environment.production;
    this.appName = environment.appName;
    const user = "";
    const pwd = "";

    this.loginForm = this.fb.group({
      email: [user, [Validators.required, Validators.email]],
      pwd: [pwd, [Validators.required, Validators.minLength(6)]],
      remember: [false],
    });
  }

  ngOnInit() {
    
   if(this.userServices.validateToken() && this.userServices.getUser().organizations.length > 0){
      this.router.navigateByUrl("pages/dashboard");
    }

    if(this.userServices.getUserEmail()){
      this.loginForm.controls.remember.setValue(true);
      this.loginForm.controls.email.setValue(this.userServices.getUserEmail());
    }
   }

  disableLogin() {
    return !(
      this.loginForm.controls.email.value && this.loginForm.controls.pwd.value && this.loginForm.controls.pwd.valid && this.loginForm.controls.email.valid
    );
  }

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
    this.token = captchaResponse;
  }

  onLogin() {
    const user:LoginModel = {
      email: this.loginForm.controls.email.value,
      password: this.loginForm.controls.pwd.value,
    };

    this.isLoading = true;
    this.logIn(user);
  }

  private logIn(user: LoginModel) {
    this.authService.login(user).then((response) => {
      if (response) {
        const tokenSanitized = response.data.token as string;
        this.isLoading = false;
        this.remember();
        this.userServices.setUser(tokenSanitized);
        const userLogged = this.userServices.getUser();

        if (userLogged.organizations.length === 0) {
          this.createOrganization();
        }
        else {
          this.router.navigateByUrl("pages/dashboard");
        }
      }
      else {
        this.notification.show('error', "Login Failed", "There is an error trying to login", 'top', { nzDuration: 3000 });
      }
    },
      (error) => {
        this.isLoading = false;
        this.notification.show('error', 'Error', error.error.error.message, 'topRight');
      }
    );
  }

  private remember() {
    if (this.loginForm.controls.remember.value) {
      this.userServices.rememberUserEmail(this.loginForm.controls.email.value);
    }
    else {
      this.userServices.removeUserEmail();
    }
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  onSignUp(){
    this.router.navigateByUrl("/sign-up");
  }

  createOrganization = () => {
      const modal = this.modalService.create({
        nzTitle: 'Create Organization',
        nzContent: CreateOrganizationComponent,
        nzData: {isEdit: false},
        nzStyle: { height: '90%'},
        nzWrapClassName: 'ant-modal-body-without-padding',
        nzViewContainerRef: this.viewContainerRef,
        nzFooter: null,
      });
      modal.afterClose.subscribe((result) => {
        if (result) {

          const user:LoginModel = {
            email: this.loginForm.controls.email.value,
            password: this.loginForm.controls.pwd.value,
          };
      
         this.logIn(user)
        }
      });
    }
}
